import { ALERT } from '../constants/actionTypes'

const uploadActions = (alert = {severity: 'success', message: 'Alert message', duration: 5000, display: false}, action) => {
    switch (action.type) {
        case ALERT:
            return action.payload;
        default:
            return alert;
    }
}

export default uploadActions